import Vue from 'vue'
import Router from 'vue-router'

const defaultRoutes = [

    // 当访问路径为 / 时，重定向到登录页面
    {
      path: '/',
      redirect: '/login'
    },

    // 登录组件
    {
      path: '/login',
      name: 'Login',
      component: () => import('../components/login/userLogin')
    },

    // 后台管理页面相关组件
    {
      path: '/admin',
      name: 'Admin',
      component: () => import('../components/admin/AdminIndex'),
      meta: {
        requireAuth: true
      },
      // 后台管理页面下的子组件
      children: [

        // 运行情况
        {
            path: 'dashboard',
            name: 'Dashboard',
            component: () => import('../components/admin/dashboard/index')
        },

        // 2026年5月13日09:49:41.添加消息预警功能 /admin/messageAlert
        {
            path: 'MessageAlert',
            name: 'projectfile/messageAlert',
            component: () => import('../components/admin/dashboard/messageAlert')
        },

        // 子组件：用户信息
        {
          path: 'user/profile',
          name: 'Profile',
          component: () => import('../components/admin/user/UserManager')
        },

        // 2025年9月20日15:08:10,个人信息
        {
          path: '/user/personalInfo',
          name: 'PersonalInfo',
          component: () => import('../components/admin/user/PersonalInfo')
        },


        // 子组件：角色信息
        {
          path: 'role/profile',
          name: 'Role',
          component: () => import('../components/admin/roleprofile/Role')
        },

        // 子组件：菜单信息
        {
          path: 'menu/profile',
          name: 'MenuManger',
          component: () => import('../components/admin/menufile/MenuManger')
        },

        // 子组件：部门管理
        {
          path: 'dept/profile',
          name: 'Dept',
          component: () => import('../components/admin/deptfile/AdminDept')
        },

        // 子组件：新建项目
        {
          path: 'project/newproject',
          name: 'NewProject',
          component: () => import('../components/admin/createProject/newProject')
        },


        // 我的项目
        {
          path: 'project/myproject',
          name: 'MyProject',
          component: () => import('../components/admin/myProject/myproject')
        },
        
        // 项目进度
        {
          path: 'project/process',
          name: 'ProjectProcess',
          component: () => import('../components/admin/projectfile/projectprocess')
        },

        // 质量管理
        {
          path: 'project/quality',
          name: 'QualityControl',
          component: () => import('../components/admin/qualityManager/qualityControl')
        },


        // 安全管理
        {
          path: 'project/security',
          name: 'SecurityControl',
          component: () => import('../components/admin/securityManager/securityControl')
        },

        // 2026年4月3日13:15:24,市政周报管理
        {
          path: 'project/municipalInfo',
          name: 'Municipal',
          component: () => import('../components/admin/municipalManager/securityControl')
        },


        // 2026年10月7日22:07:00,光伏工程周报管理
        {
          path: 'project/photol',
          name: 'Photol',
          component: () => import('../components/admin/photolManager/qualityControl')
        },



        // 项目台账
        {
          path: 'project/projectLedger',
          name: 'ProjectLedger',
          component: () => import('../components/admin/projectfile/projectLedger')
        },


        // 2025年2月17日09:01:18 -- 新增 申请单管理

        // 申请单管理--费用申请单
        {
          path: 'cost/costApplication',
          name: 'NotesManager',
          component: () => import('../components/admin/cost/costApplication')
        },

        // 申请单管理--我的申请单
        {
          path: 'cost/myApplication',
          name: 'NotesManager',
          component: () => import('../components/admin/cost/myApplication')
        },

        // 财务管理--我的申请单
        {
          path: 'financial/applicationlist',
          name: 'NotesManager',
          component: () => import('../components/admin/financial/applicationlist')
        },
        

        // 周报管理
        {
          path: 'project/reportManager',
          name: 'reportManager',
          component: () => import('../components/admin/weekReportMangement/reportManager')
        },


        
        // 2025年8月25日10:30:37,启用以下内容
        // 项目勘察
        {
          path: 'projectSurvey',
          name: 'ProjectSurvey',
          component: () => import('../components/admin/informationManager/ProjectSurvey')
        },

        // 项目记录
        {
          path: 'projectRecords',
          name: 'ProjectRecords',
          component: () => import('../components/admin/informationManager/ProjectRecords')
        },

        // 项目论证
        {
          path: 'projectDemonstration',
          name: 'ProjectDemonstration',
          component: () => import('../components/admin/informationManager/ProjectDemonstration')
        },

        // 监理合同
        {
          path: 'superviseContract',
          name: 'SuperviseContract',
          component: () => import('../components/admin/informationManager/SuperviseContract')
        }, 

        // 项目授权
        {
          path: 'projectAuthorization',
          name: 'ProjectAuthorization',
          component: () => import('../components/admin/informationManager/ProjectAuthorization')
        }, 

        // 工程纪令
        {
          path: 'projectDiscipline',
          name: 'ProjectDiscipline',
          component: () => import('../components/admin/informationManager/ProjectDiscipline')
        },  

        // 监理规划
        {
          path: 'supervisionPlanning',
          name: 'SupervisionPlanning',
          component: () => import('../components/admin/informationManager/SupervisionPlanning')
        },

        // 2025年9月9日09:31:38,新增的功能模块
        // 安全巡检
        {
          path: 'inspection/:safeDetailId?',
          name: 'SafeInspection',
          component: () => import('../components/admin/inspeCheck/inspection'),
          props: (route) =>({
            // 同时支持params和query两种参数传递方式
            safeDetailId: route.params.safeDetailId,
            projectId: route.params.projectId || route.query.projectId
          })
        },


        // 质量巡检
        {
          path: 'qualition/:qualityDetailId?',  // 添加动态参数
          name: 'Qualitytion',
          component: () => import('../components/admin/qualityCheck/inspection'),
          // props: true  // 启用props接收参数
          props: (route) =>({
            // 同时支持params和query两种参数传递方式
            qualityDetailId: route.params.qualityDetailId,
            projectId: route.params.projectId || route.query.projectId
          })
        },


        // 总监巡检
        {
          path: 'director/:directDetailId?',
          name: 'DirectorCheck',
          component: () => import('../components/admin/directorCheck/inspection')
        },

        // 内部会议安排
        {
          path: 'internalMeeting/:meetDetailId?',
          name: 'InternalMeeting',
          component: () => import('../components/admin/meeting/internalMeeting'),
          props: (route) =>({
            meetDetailId: route.params.meetDetailId,
            projectId: route.params.projectId || route.query.projectId,
            meetId: route.params.meetId || route.query.meetId
          })
        },


        // 2025年10月10日16:12:07,工程指令
        {
          path: 'engineerInstruction',
          name: 'EngineerInstruction',
          component: () => import('../components/admin/engineerInstruction/engineerInstruction'),
        },




        // 资料管理
        {
          path: 'materialInfo',
          name: 'MaterialManager',
          component: () => import('../components/admin/material/materialInfo')
        },


        // 2025年9月16日09:02:04,新加 公告管理组件
        // 子组件：发布公告
        {
          path: 'noticeManager/publishNotice',
          name: 'NoticeInfoManager',
          component: () => import('../components/admin/noticeManager/publishNotice')
        },

        // 子组件：公告列表
        {
          path: 'noticeManager/noticeInfo',
          name: 'NoticeInfoManager',
          component: () => import('../components/admin/noticeManager/noticeInfo')
        },
      ]

    }
  ]



// 创建一个可以根据传入路由数组生成新路由的函数
export const createRouter = (routes = defaultRoutes)  => new Router({
  mode: 'history',
  routes
})

// 初始化路由
const router =createRouter();

Vue.use(Router)

export default router;